type Listener = () => void;

interface AuthState {
  user: { id: number; login: string; role: string; email: string | null } | null;
  csrfToken: string | null;
  isLoading: boolean;
}

class AuthStore {
  private state: AuthState = {
    user: null,
    csrfToken: null,
    isLoading: true,
  };
  private listeners: Set<Listener> = new Set();

  getState(): AuthState {
    return this.state;
  }

  setState(partial: Partial<AuthState>): void {
    this.state = { ...this.state, ...partial };
    this.notify();
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private notify(): void {
    for (const listener of this.listeners) {
      listener();
    }
  }

  async checkAuth(): Promise<void> {
    try {
      const res = await fetch('/api/auth/me', { credentials: 'include' });
      if (res.ok) {
        const data = await res.json() as { user: { id: number; login: string; role: string; email: string | null }; csrfToken: string };
        this.setState({ user: data.user, csrfToken: data.csrfToken, isLoading: false });
      } else {
        this.setState({ user: null, csrfToken: null, isLoading: false });
      }
    } catch {
      this.setState({ user: null, csrfToken: null, isLoading: false });
    }
  }
}

export const authStore = new AuthStore();
